import React from 'react';
import GenericModal from "../GenericModal";
import {Field, Formik} from "formik";
import TextField from "../../Ui/TextField";
import useLocationData from "../../../hooks/DataProvider/useLocationData";
import MenuItem from "@material-ui/core/MenuItem";
import useDonneeTechniqueData from "../../../hooks/DataProvider/useDonneeTechniqueData";
import Divider from "@material-ui/core/Divider";

export default function SearchFicheModal(props){

    const {children,onCancel,onSearch,initialValues} = props
    const [isOpened,setIsOpened] = React.useState(false);
    const formikRef = React.useRef(null);

    const [isLoadingVilles,villes] = useLocationData('villes')
    const [isLoadingCommunes,communes] = useLocationData('communes')

    const [isLoadingNaturesTravaux,natureTravaux] = useDonneeTechniqueData('nature_travaux')



    function open(){
        setIsOpened(true)
    }

    function onYes(){
        if(formikRef && formikRef.current)
            formikRef.current.submitForm();
    }

    return (
        <div className={'d-inline-block'}>

            <div className={'d-inline-block'} onClick={open}>
                {children}
            </div>


            <GenericModal
                isOpen={isOpened}
                onNegative={()=>{
                    setIsOpened(false)
                }}
                onPositive={onYes}
                positiveText={'Rechercher'}
                negativeText={'Annuler'}
                title={'Recherche de fiche'}
            >

                <Formik
                    innerRef={formikRef}
                    initialValues={initialValues}
                    onSubmit={(values,formikHelpers)=>{

                        setIsOpened(false)
                        formikHelpers.setSubmitting(false);
                        onSearch(values);

                    }}
                >

                    {
                        () => {
                            return (
                                <div>

                                    <div className={'row'}>

                                        <div className="col-lg-6 my-3">
                                            <Field
                                                name={'nom'}
                                                component={TextField}
                                                label={'Nom'}
                                            />
                                        </div>

                                        <div className="col-lg-6 my-3">
                                            <Field
                                                name={'prenoms'}
                                                component={TextField}
                                                label={'Prénoms'}
                                            />
                                        </div>

                                        <div className="col-lg-6 my-3">
                                            <Field
                                                name={'raison_sociale'}
                                                component={TextField}
                                                label={'Raison sociale'}
                                            />
                                        </div>

                                        <div className="col-lg-6 my-3">
                                            <Field
                                                name={'mobile'}
                                                component={TextField}
                                                label={'Numéro de téléphone'}
                                            />
                                        </div>

                                        <div className={'col-12 my-5'}>
                                            <Divider />
                                        </div>

                                        <div className="col-lg-6 my-3">
                                            <Field
                                                name={'villes'}
                                                component={TextField}
                                                select
                                                label={'Villes'}
                                                SelectProps={{
                                                    multiple: true
                                                }}
                                            >


                                                {
                                                    villes.map(
                                                        ville => (
                                                            <MenuItem value={ville.id} key={ville.id}>
                                                                {ville.libelle}
                                                            </MenuItem>
                                                        )
                                                    )
                                                }

                                            </Field>
                                        </div>

                                        <div className="col-lg-6 my-3">
                                            <Field
                                                name={'communes'}
                                                component={TextField}
                                                select
                                                label={'Communes'}
                                                SelectProps={{
                                                    multiple: true
                                                }}
                                            >

                                                {
                                                    communes.map(
                                                        commune => (
                                                            <MenuItem value={commune.id} key={commune.id}>
                                                                {commune.libelle}
                                                            </MenuItem>
                                                        )
                                                    )
                                                }

                                            </Field>
                                        </div>


                                        <div className={'col-12 my-5'}>
                                            <Divider />
                                        </div>


                                        <div className="col-lg-6 my-3">
                                            <Field
                                                name={'code'}
                                                component={TextField}
                                                label={'Numéro de demande'}
                                            />
                                        </div>

                                        <div className="col-lg-6 my-3">
                                            <Field
                                                name={'societe'}
                                                component={TextField}
                                                select
                                                label={'Societé'}
                                            >

                                                <MenuItem value={'cie'}>
                                                    CIE
                                                </MenuItem>

                                                <MenuItem value={'sodeci'}>
                                                    SODECI
                                                </MenuItem>

                                                <MenuItem value={'all'}>
                                                    CIE & SODECI
                                                </MenuItem>

                                            </Field>
                                        </div>

                                        <div className="col-lg-6 my-3">
                                            <Field
                                                name={'natures_travaux'}
                                                component={TextField}
                                                select
                                                label={'Objet de la demande'}
                                                SelectProps={{
                                                    multiple: true
                                                }}
                                            >

                                                {
                                                    natureTravaux.map(
                                                        item => (
                                                            <MenuItem value={item.id} key={item.id}>
                                                                {item.libelle}
                                                            </MenuItem>
                                                        )
                                                    )
                                                }

                                            </Field>
                                        </div>


                                        <div className="col-lg-6 my-3">
                                            {/*<Field*/}
                                            {/*    name={'state'}*/}
                                            {/*    component={TextField}*/}
                                            {/*    select*/}
                                            {/*    label={'Status de la demande'}*/}
                                            {/*>*/}

                                            {/*</Field>*/}
                                        </div>

                                    </div>

                                </div>
                            )
                        }
                    }

                </Formik>

            </GenericModal>


        </div>

    )
}